<template>
  <div class="footer-container">
    <div class="footer-nav-container hidden-xs-only">
      <el-row class="footer-nav-list" :gutter="20">
        <el-col
          :span="6"
          class="navItem"
          v-for="item in nav_list"
          :key="item.name">
          <div class="navItem-name" @click="handleMenuClick(item)">{{ item.name }}</div>
          <div class="subItem-container">
            <div
              class="subItem-name"
              v-for="subItem in item.children"
              :key="subItem.name">
              <div @click="handleMenuClick(item, subItem)">
                - {{ subItem.name }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="footer-content">
      <div class="copyright">
        {{ copyright_info.base_info }}
        <a target="_blank" href="https://beian.miit.gov.cn">
          {{ copyright_info.icp_number }}
        </a>
      </div>
      <div class="wangAn">
        <img src="/static/imgs/footer_beian.png" alt="">
        <a target="_blank" :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' + copyright_info.wangAn_beiAn_number">
          {{ copyright_info.wangAn_beiAn_info }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    // 导航列表
    nav_list() {
      return this.$store.state.nav.content.nav_list.slice(1);
    },
    // 版权信息
    copyright_info() {
      return this.$store.state.common.content.copyright_info;
    }
  },
  methods: {
    // 导航点击事件
    handleMenuClick(item, subItem) {
      this.isMenuOpen = false;
      if (subItem) {
        if (subItem.path) {
          this.navigate(subItem.path);  // 处理路径跳转
        } else {
          if (this.$route.hash == `#${subItem.anchor}`) {
            this.scrollTo(subItem.anchor)
          } else {
            this.$router.push(`${item.link}#${subItem.anchor}`);
          }
        }
      } else {
        // 处理点击菜单项
        this.navigate(item.link);
      }
    },
    // 用于处理路由跳转的逻辑
    navigate(path) {
      if (this.$route.path === path) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        this.$router.push(path);
      }
    },
    // 滚动到指定锚点
    scrollTo(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.footer-container {
  background-image: url('/static/imgs/footer_bg.png');
  background-size: 100% 100%;
  width: 100%;
}

/* 导航 */
.footer-container .footer-nav-container {
  width: 100%;
  padding: 80px 0;
  border-bottom: 1px solid #2b2f2f;
  .footer-nav-list {
    width: var(--max);
    margin: auto !important;
  }
  .navItem .navItem-name {
    line-height: 2;
    color: #ffffff;
    font-size: var(--font16);
    cursor: pointer;
  }
  .subItem-container {
    margin-top: 30px;
    .subItem-name {
      line-height: 2;
      margin-bottom: 10px;
      color: #ffffff;
      font-size: var(--font14);
      cursor: pointer;
    }
  }
}

/* 内容 */
.footer-container .footer-content {
  width: var(--max);
  margin: auto;
  padding: 60px 0 150px 0;
  .copyright {
    margin-top: 20px;
    font-size: var(--font14);
    text-align: center;
    color: #ffffff;
    line-height: 2;
  }
  .wangAn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: var(--font14);
    img {
      margin-right: 10px;
    }
  }
}

/* 视口小于 768px 时需调整的样式 */
@media screen and (max-width: 768px) {
  .footer-container .footer-content {
    padding: 40px 0 80px 0;
    & > p:first-child {
      display: flex;
      flex-direction: column;
      align-items: center;
      a {
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue